import imageIcon from './../svg/imageIcon.svg';
import pdfIcon from './../svg/pdfIcon.svg';
import videoIcon from './../svg/youtube.svg';

export const getFileTypeIcon = (fileType: string) => {
  if (fileType.startsWith('image/')) {
    return <img src={imageIcon} alt="Logo" style={{ height: 25 }} />;
  }

  if (fileType === 'application/pdf') {
    return <img src={pdfIcon} alt='Logo' style={{ height: 25 }} />;
  }

  if (fileType === 'video/mp4') {
    return <img src={videoIcon} alt='Logo' style={{ height: 25 }} />;
  }

  return <img src={pdfIcon} alt='Logo' style={{ height: 25 }} />;
};